<template>
    <div class="w-full flex justify-end pb-20"
    @keyup.enter="sendData"
    >
    <button class="text-xl mr-8 my-16 text-gray-500  hover:text-gray-200 text-1.8rem"
    @click.prenvent="toggleSidebar()"
    >
        <i class="fa fa-search"></i> {{mq.xs ? '' : 'Ricerca Artista'}} 
    </button>
    <div v-if="openSearchBar" class="fixed right-0 w-35rem z-50 h-screen bg-slate-900 top-0 overflow-auto py-16 searchbar">
        <div class="close-sidebar justify-end flex">
            <button class="text-2xl p-4"
            @click.prenvent="toggleSidebar()"
            >
                <i class="fa fa-close"></i>
            </button>
        </div>
        <p class="text-2.3rem text-center">Ricerca Avanzata Artista</p>
        <div class="flex lg:flex-wrap flex-col mdr:mb-52">
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Nome e Cognome</label>
                <input v-model="nomecompleto" class="p-4 w-full text-black" />
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Età Min</label>
                <input v-model="age_min" class="p-4 w-full text-black" />
                <p class="text-1.2rem text-gray-700 leading-mini">da 5 a 99</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Età Max</label>
                <input v-model="age_max" class="p-4 w-full text-black" />
                <p class="text-1.2rem text-gray-700 leading-mini">da 5 a 99</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Nazionalità</label>
                <input v-model="nazionalita" class="p-4 w-full text-black" />
                <p class="text-1.2rem text-gray-700 leading-mini">Inserire il nome della nazionalità</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Regione</label>
                <input v-model="regione_di_residenza" class="p-4 w-full text-black" />
                <p class="text-1.2rem text-gray-700 leading-mini">inserire più di due caratteri</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Residenza</label>
                <input v-model="citta_di_residenza" class="p-4 w-full text-black" />
                <p class="text-1.2rem text-gray-700 leading-mini">Inserire città di residenza</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Domicilio</label>
                <input v-model="citta_di_domicilio" class="p-4 w-full text-black" />
                <p class="text-1.2rem text-gray-700 leading-mini">Inserire città di domicilio</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Appoggi</label>
                <input v-model="appoggi" class="p-4 w-full text-black" />
                <p class="text-1.2rem text-gray-700 leading-mini">Inserire città</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Altezza</label>
                <input v-model="altezza" class="p-4 w-full text-black" />
                <p class="text-1.2rem text-gray-700 leading-mini">Espressa in cm</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Sesso</label>
                <select  v-model="sesso" class="w-full p-4 text-black">
                    <option v-for="(option,index) in optionsSesso" :key="index" :value="option.val">
                    {{ option.name }}
                    </option>
                </select>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Capelli</label>
                <select  v-model="capelli" class="w-full p-4 text-black">
                    <option v-for="(option,index) in optionsCapelli" :key="index" :value="option.val">
                    {{ option.name}}
                    </option>
                </select>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Occhi</label>
                <select  v-model="occhi" class="w-full p-4 text-black">
                    <option v-for="(option,index) in optionsOcchi" :key="index" :value="option.val">
                    {{ option.name}}
                    </option>
                </select>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Etnia</label>
                <select  v-model="etnia" class="w-full p-4 text-black">
                    <option v-for="(option,index) in optionsEtnia" :key="index" :value="option.val">
                    {{ option.name}}
                    </option>
                </select>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Carnagione</label>
                <select  v-model="carnagione" class="w-full p-4 text-black">
                    <option v-for="(option,index) in optionsCarnagione" :key="index" :value="option.val">
                    {{ option.name}}
                    </option>
                </select>
            </div>
           <!-- <div class="w-full p-8">
                <label class="font-bold block text-xl mb-2">Costituzione</label>
                <select  v-model="costituzione" class="w-full p-4 text-black">
                    <option v-for="(option,index) in optionsCostituzione" :key="index" :value="option.val">
                    {{ option.name}}
                    </option>
                </select>
            </div>-->
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Lingua</label>
                <input v-model="lingua" class="p-4 w-full text-black" />
                <p class="text-1.2rem text-gray-700 leading-mini">Inserire il nome della lingua</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Livello Lingua</label>
                <select  v-model="livello" class="w-full p-4 text-black">
                    <option v-for="(option,index) in optionsLivello" :key="index" :value="option.val">
                    {{ option.name}}
                    </option>
                </select>
                <p v-if="error" class="text-red-500">Seleziona un livello di lingua!</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Dialetti</label>
                <input v-model="dialetti" class="p-4 w-full text-black" />
                <p class="text-1.2rem text-gray-700 leading-mini">Inserire il nome del dialetto</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Dizione</label>
                <select  v-model="dizione" class="w-full p-4 text-black">
                    <option v-for="(option,index) in optionsDizione" :key="index" :value="option.val">
                    {{ option.name}}
                    </option>
                </select>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Sport</label>
                <input v-model="sport" class="p-4 w-full text-black" />
                <p class="text-1.2rem text-gray-700 leading-mini">Nome sport</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Canto</label>
                <select  v-model="canto" class="w-full p-4 text-black">
                    <option v-for="(option,index) in optionsCanto" :key="index" :value="option.val">
                    {{ option.name}}
                    </option>
                </select>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Strumenti Musicali</label>
                <input v-model="strumenti" class="p-4 w-full text-black" />
                <p class="text-1.2rem text-gray-700 leading-mini">Nome strumento</p>
            </div>
            <div class="w-full py-4 px-8">
                <label class="font-bold block text-xl mb-2">Danza</label>
                <select  v-model="danza" class="w-full p-4 text-black">
                    <option v-for="(option,index) in optionsDanza" :key="index" :value="option.val">
                    {{ option.name}}
                    </option>
                </select>
            </div>
        <div class="w-full flex flex-wrap justify-center">
            <button
            @click.prevent="sendData"
            >Avvia ricerca</button>
        </div>
        </div>
    </div>
    </div>
</template>
<script>
import {getTransitionRawChildren, ref} from 'vue';
import { useMq } from "vue3-mq";
    export default {
    name: 'search-artist',
    inject:['mq'],
    emits: ['toggle'],
    data(){
        return{
            error:false,
            openSearchBar: false,
            blockPage: true,
            age_min:'',
            age_max:'',
            nomecompleto: '',
            altezza: '',
            capelli: '',
            sesso:'',
            occhi:'',
            etnia:'',
            carnagione:'',
            //costituzione:'',
            sport:'',
            canto:'',
            danza:'',
            strumenti:'',
            nazionalita:'',
            regione:'',
            citta_di_residenza:'',
            citta_di_domicilio:'',
            regione_di_residenza:'',
            appoggi:'',
            lingua:'',
            dialetti:'',
            dizione:'',
            livello: 0,
            optionsSesso:[
                {name: 'Seleziona Opzione', val:''},
                {name: 'Maschio', val:'maschio'},
                {name: 'Femmina', val:'femmina'},
            ],
            optionsOcchi:[
                {name: 'Seleziona Opzione', val:''},
                {name: 'Neri', val:'neri'},
                {name: 'Marroni', val:'marroni'},
                {name: 'Azzurri', val:'azzurri'},
                {name: 'Verdi', val:'verdi'},
                {name: 'Grigi', val:'grigi'},
                {name: 'Bruni', val:'bruni'},
                
            ],
            optionsEtnia:[
                {name: 'Seleziona Opzione', val:''},
                {name: 'Europea', val:'1'},
                {name: 'Mediterranea', val:'3'},
                {name: 'Africana', val:'4'},
                {name: 'Caucasica', val:'2'},
                {name: 'Asiatica', val:'5'},
                
            ],
            optionsCarnagione:[
                {name: 'Seleziona Opzione', val:''},
                {name: 'Chiara', val:'chiara'},
                {name: 'Olivastra', val:'olivastra'},
                {name: 'Scura', val:'scura'},
                
                
            ],
            optionsCapelli:[
                {name: 'Seleziona Opzione', val:''},
                {name: 'Biondi Chiaro', val:'biondi chiaro'},
                {name: 'Biondi Scuro', val:'biondi scuro'},
                {name: 'Castani', val:'castani'},
                {name: 'Neri', val:'neri'},
                {name: 'Rossi', val:'rossi'},
                {name: 'Grigi', val:'grigi'},
                {name: 'Bruni', val:'bruni'},
                
            ],
            /*optionsCostituzione:[
                {name: 'Seleziona Opzione', val:''},
                {name: 'Esile', val:'esile'},
                {name: 'Normale', val:'normale'},
                {name: 'Atletica', val:'atletica'},
                {name: 'Robusta', val:'robusta'}, 
            ],*/
            optionsCanto:[
                {name: 'Seleziona Opzione', val:''},
                {name: 'Intonato', val:'intonato'},
                {name: 'Lirico', val:'lirico'},
                {name: 'Jazz', val:'jazz'},
                {name: 'Moderno', val:'moderno'}, 
                {name: 'Solfeggio', val:'solfeggio'}, 
            ],
            optionsDanza:[
                {name: 'Seleziona Opzione', val:''},
                {name: 'Moderna', val:'moderna'},
                {name: 'Classica', val:'classica'},
                {name: 'Contemporanea', val:'contemporanea'},
                {name: 'Latino', val:'latino'}, 
                {name: 'Pop', val:'pop'}, 
                {name: 'Hip-pop', val:'Hip-pop'}, 
                {name: 'Break dance', val:'break dance'}, 
                {name: 'Tip Tap', val:'tip tap'}, 
                {name: 'Tango', val:'tango'}, 
                {name: 'Liscio', val:'liscio'}, 
            ],
            optionsStrumenti:[
                {name: 'Seleziona Opzione', val:''},
                {name: 'Lirico', val:'lirico'},
                {name: 'Jazz', val:'jazz'},
                {name: 'Moderno', val:'moderno'}, 
                {name: 'Solfeggio', val:'solfeggio'},
            ],
            optionsLivello:[
                {name: 'Seleziona Opzione', val:0},
                {name: 'Scolastico', val:1},
                {name: 'Discreto', val:2},
                {name: 'Buono', val:3},
                {name: 'Ottimo', val:4},
                {name: 'Madrelingua', val:5},
            ],

            optionsDizione:[
                {name: 'Seleziona Opzione', val:0},
                {name: 'Discreta', val:'Discreta'},
                {name: 'Buona', val:'Buona'},
                {name: 'Ottima', val:'Ottima'},
            ]
        
        }
    },
    
    beforeDestroy() {
    document.body.style.overflow = "";
    },
    methods:{
        sendData(){
            this.error = false
            if (this.lingua && this.livello == 0) {
                this.error = true;
                return false
            }
            this.blockPage=true
            let query = {}
            this.age_min? query.age_min = this.age_min :  null
            this.age_max? query.age_max = this.age_max :  null
            this.sesso ? query.sesso = this.sesso : null
            this.citta_di_residenza ? query.citta_di_residenza = this.citta_di_residenza : null,
            this.citta_di_domicilio ? query.citta_di_domicilio = this.citta_di_domicilio : null,
            this.appoggi ? query.appoggi = this.appoggi : null,
            this.nazionalita ? query.nazionalita = this.nazionalita : null,
            this.regione_di_residenza ? query.regione_di_residenza = this.regione_di_residenza : null,
            this.altezza ? query.altezza = this.altezza : null
            this.occhi ? query.occhi = this.occhi : null
            this.etnia ? query.etnia = this.etnia : null
            this.carnagione ? query.carnagione = this.carnagione : null
            this.capelli ? query.capelli = this.capelli :null
            this.costituzione ? query.costituzione = this.costituzione :null
            this.sport ? query.sport = this.sport : null
            this.canto ? query.canto = this.canto :null
            this.danza ? query.danza =this.danza : null
            this.lingua ? query.lingua = this.lingua : null
            this.livello != 0 ? query.livello = this.livello : null
            this.dizione ? query.dizione = this.dizione : null
            this.dialetti ? query.dialetti = this.dialetti : null

            this.strumenti ? query.strumenti =this.strumenti : null
            this.nomecompleto ? query.nomecompleto =this.nomecompleto : null
            
           

            this.toggleSidebar()
            this.$emit('toggle',query) 
           
        },
        toggleSidebar(){
            this.openSearchBar = !this.openSearchBar
            this.openSearchBar ? document.body.style.overflow = 'hidden' : document.body.style.overflow= 'scroll' 
        },
    }
    }
</script>

<style lang="scss" scoped>
.searchbar{
    z-index: 500;
}
</style>